const routes = {
  _wildcard: '*',
  accountBillingTab: '/account/billing/:tab?',
  accountContact: '/account/contact',
  accountDue: '/account/billing/dues/:id',
  accountEvent: '/account/event/:id/:action?',
  accountInvoices: '/account/billing/invoices',
  accountMembershipNomination: '/account/memberships/:id/nominate',
  accountMembershipSubmember: '/account/memberships/:id/submembers',
  accountMemberships: '/account/memberships/:id?',
  accountOrder: '/account/billing/orders/:id',
  accountOrders: '/account/billing/orders',
  accountPerksTab: '/account/perks',
  accountProfileTab: '/account/profile/:tab?',
  accountStatement: '/account/billing/statements/:id',
  accountTab: '/account/:tab',
  accountTransaction: '/account/billing/transactions/:id',
  accountWalletBank: '/account/wallet/payment-methods/bank-accounts/:id',
  accountWalletCreate: '/account/wallet/payment-methods/create',
  accountWalletCreditCard: '/account/wallet/payment-methods/credit-cards/:id',
  accountWalletTab: '/account/wallet/:tab?',
  accountWalletTicket: '/account/wallet/tickets/:id',
  account: '/account/:root?',

  actions: '/actions/:action?',
  activate: '/activate/:code',
  activity: '/activities',
  activityId: '/activities/:id',
  appointment: '/appointments/:id',
  appointments: '/appointments',
  blog: '/blogs',
  blogId: '/blogs/:id',
  calendarRedirect: '/redirect/calendar/:type',
  checkout: '/checkout',
  clubBenefits: '/club-benefits/:tab/:id',
  clubBenefitsTab: '/club-benefits/:tab?',
  clubBenefitsTabs: '/club-benefits/:tab?',
  cookie: '/cookie',
  dining: '/dining/:id/:tab?',
  diningCategory: '/dining/categories',
  dinings: '/dining',
  directory: '/directory',
  directoryTab: '/directory/:tab?',
  directoryCompany: '/directory/companies/:id',
  directoryMember: '/directory/members/:id',
  directoryPage: '/directory/:tab/:id',
  event: '/events/:id',
  events: '/events',
  faq: '/faq/:arg?',
  forgotPassword: '/forgot-password',
  generalError: '/error/:response?',
  guestList: '/guest-pass',
  guestPassShare: '/guest-pass/:id/:pin?',
  guestTicket: '/guest-tickets/:serial',
  guestVoucher: '/guest-vouchers/:id/:pin',
  index: '',
  message: '/messages/:id?',
  messages: '/messages',
  myClub: '/my-club',
  mySchedule: '/my-schedule',
  myScheduleAppointments: '/my-schedule/appointment/:id',
  myScheduleBooking: '/my-schedule/:type/:id',
  myScheduleEvent: '/my-schedule/event/:id',
  myScheduleReservations: '/my-schedule/reservation/:id',
  notifications: '/notifications',
  notificationsTab: '/notifications/:tab',
  pageId: '/pages/:id',
  passbookDownload: '/passbook/:id',
  register: '/register',
  room: '/rooms/:id',
  rooms: '/rooms',
  shop: '/product',
  shopCategory: '/product/categories',
  shopMenu: '/product/menu',
  spa: '/spa-wellness/:id',
  spas: '/spa-wellness',
  static: '/(terms|privacy|cookie)',
  survey: '/survey/:id',
  unsubscribeEmail: '/unsubscribe',
  userLogin: '/auth/login',
  userLogout: '/logout',
  userPasswordReset: '/password-reset',
  verifyEmail: '/verify-email',
  verifySms: '/verify-sms',
  voucher: '/vouchers/:id',
} as const

export { routes }
export default routes
